import React, { Fragment, useState } from 'react'
import imgShare from "../../Assets/images/share.png";
import qrCode from "../../Assets/images/qrCode.png"
import { Link } from 'react-router-dom'
import CustomTitle from '../CustomTitle/CustomTitle.jsx';
import style from "./content.module.css"
import whatsAppIcon from "../../Assets/images/whatsapp.png"

export default function Contact() {
   const [copied, setCopied] = useState(false);
   const textToCopy = process.env.REACT_APP_FRONT_URL;

   const handleCopy = async () => {
      try {
         await navigator.clipboard.writeText(textToCopy);
         setCopied(true);
         setTimeout(() => setCopied(false), 3000); // يرجع الزر تاني بعد ٢ ثانية
      } catch (err) {
         console.error("Failed to copy: ", err);
      }
   };
   return (
      <Fragment>
         <CustomTitle title="التواصل " />

         <div className="container content-container">
            <h1 className='main-header'>Contact Us</h1>
            <div className='under-header'></div>

            <h1 className="fs-4 text-center mb-4 fs-bold">Smart Trend - سمارت تريند </h1>
            <div className="row">


               <div className="row align-item-center">

                  <div className="col-md-6 text-center">
                     <div className='w-100 text-center '>
                        <img src={imgShare} className='w-100' alt="qrCode" />
                     </div>
                  </div>

                  <div className="col-md-6 text-center mt-4">
                     <div className="container my-4" dir="rtl">
                        <div className="card shadow-sm border-0 mb-3">
                           <div className="card-body">
                              <h5 className="card-title fw-bold text-end">  العنوان (Address) 📍</h5>
                              <p className="card-text text-end mb-1 fs-5">
                                 العنوان: عمارة  188 شقة 1  الحي الرابع  - التجمع الخامس - امام ارابيلا  بلازا
                              </p>
                           </div>
                        </div>

                        <div className="card shadow-sm border-0">
                           <div className="card-body">
                              <h5 className="card-title fw-bold text-end">  تواصل معنا (Contact Us) 📞</h5>
                              <p className="card-text text-end mb-1 fs-5" dir='rtl'>
                                 رقم الهاتف:    01066991090
                              </p>
                              <p className="card-text text-end mb-1 fs-5">
                                 البريد الإلكتروني: <Link to="mailto:info@sm-trend.com" className='text-black'>info@sm-trend.com</Link>
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="text-center">
                     <p>{textToCopy}</p>
                     <button onClick={handleCopy} className="btn bg-main">
                        {copied ? "✔️ تم النسخ" : "📋 نسخ الرابط "}
                     </button>
                  </div>

               </div>




            </div>
            {/* WhatsApp Float Button */}
            <a
               href="https://wa.me/+201066991090"
               target="_blank"
               rel="noopener noreferrer"
               style={{
                  position: 'fixed',
                  bottom: '20px',
                  left: '20px',
                  backgroundColor: '#25D366',
                  borderRadius: '50%',
                  width: '60px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                  cursor: 'pointer',
                  zIndex: 1000,
                  transition: 'all 0.3s ease',
                  textDecoration: 'none'
               }}
               onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
               }}
               onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
               }}
            >
               <img src={whatsAppIcon} alt="WhatsApp" style={{ width: '60px', height: '60px' }} />
            </a>

            <a
               href="/#/login"
               rel="noopener noreferrer"
               style={{
                  position: 'fixed',
                  bottom: '20px',
                  right: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  width: '60px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px black',
                  cursor: 'pointer',
                  zIndex: 1000,
                  transition: 'all 0.3s ease',
                  textDecoration: 'none',
                  border: '2px solid #0d203a'
               }}
               onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 6px 20px #0d203a';
               }}
               onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px #0d203a';
               }}
            >
               <span style={{ fontSize: '45px', color: '#0d203a' }}>+</span>
            </a>
         </div>
      </Fragment>
   )
}
